import React, { createContext, ReactNode, useContext, useState } from 'react'

interface FileContextType {
    homeFile: string | null,
    setHomeFile: React.Dispatch<React.SetStateAction<string | null>>,
    reportWebVitals: string | null,
    setReportWebVitals: React.Dispatch<React.SetStateAction<string | null>>,    
    globalCss: string | null,
    setGlobalCss: React.Dispatch<React.SetStateAction<string | null>>,
    rhybusCss: string | null,
    setRhybusCss: React.Dispatch<React.SetStateAction<string | null>>,
    variableCss: string | null,
    setVariableCss: React.Dispatch<React.SetStateAction<string | null>>,    
    robotsTxt: string | null,
    setRobotsTxt: React.Dispatch<React.SetStateAction<string | null>>,    
    manifestJson: string | null,
    setManifestJson: React.Dispatch<React.SetStateAction<string | null>>,
    indexHtml: string | null,
    setIndexHtml: React.Dispatch<React.SetStateAction<string | null>>,    
    gitignore: string | null,
    setGitignore: React.Dispatch<React.SetStateAction<string | null>>,
    packagejson: string | null,
    setPackagejson: React.Dispatch<React.SetStateAction<string | null>>
    tsconfigjson: string | null,
    setTsconfigjson: React.Dispatch<React.SetStateAction<string | null>>
    appCss: string | null,
    setAppCss: React.Dispatch<React.SetStateAction<string | null>>
    appTsx: string | null,
    setAppTsx: React.Dispatch<React.SetStateAction<string | null>>
    indexTsx: string | null,
    setIndexTsx: React.Dispatch<React.SetStateAction<string | null>>
    barChartFile: string | null,
    setBarChartFile: React.Dispatch<React.SetStateAction<string | null>>,
    donutChartFile: string | null,
    setDonutChartFile: React.Dispatch<React.SetStateAction<string | null>>
    pieChartFile: string | null,
    setPieChartFile: React.Dispatch<React.SetStateAction<string | null>>
    announcementFile: string | null,
    setAnnouncementFile: React.Dispatch<React.SetStateAction<string | null>>
    knowledgeGraphFile: string | null,
    setKnowledgeGraphFile: React.Dispatch<React.SetStateAction<string | null>>
    pocFile: string | null,
    setPocFile: React.Dispatch<React.SetStateAction<string | null>>
    quicklinksFile: string | null,
    setQuicklinksFile: React.Dispatch<React.SetStateAction<string | null>>
    listviewTableFile: string | null,
    setListviewTableFile: React.Dispatch<React.SetStateAction<string | null>>
    tableCss: string | null,
    setTableCss: React.Dispatch<React.SetStateAction<string | null>>
    pagesIndex: string | null,
    setPagesIndex: React.Dispatch<React.SetStateAction<string | null>>
    router: string | null,
    setRouter: React.Dispatch<React.SetStateAction<string | null>>
    menus: string | null,
    setMenus: React.Dispatch<React.SetStateAction<string | null>>
    buttons: string | null,
    setButtons: React.Dispatch<React.SetStateAction<string | null>>
    buttonsCss: string | null,
    setButtonsCss: React.Dispatch<React.SetStateAction<string | null>>
    kpis: string | null,
    setKpis: React.Dispatch<React.SetStateAction<string | null>>
    
    customSelect: string | null,
    setCustomSelect: React.Dispatch<React.SetStateAction<string | null>>,
    inputCheckBox: string | null,
    setInputCheckBox: React.Dispatch<React.SetStateAction<string | null>>,
    inputText: string | null,
    setInputText: React.Dispatch<React.SetStateAction<string | null>>,
    inputLabel: string | null,
    setInputLabel: React.Dispatch<React.SetStateAction<string | null>>,
    inputSearch: string | null,
    setInputSearch: React.Dispatch<React.SetStateAction<string | null>>,
    inputTextarea: string | null,
    setInputTextarea: React.Dispatch<React.SetStateAction<string | null>>,
    inputSwitch: string | null,
    setInputSwitch: React.Dispatch<React.SetStateAction<string | null>>,
    pointsOfContact: string | null,
    setPointsOfContact: React.Dispatch<React.SetStateAction<string | null>>,    
    quickLinks: string | null,
    setQuickLinks: React.Dispatch<React.SetStateAction<string | null>>,  
    dashboardPage: string | null,
    setDashboardPage: React.Dispatch<React.SetStateAction<string | null>>,
     formPageComponents: any
    setFormPageComponents: React.Dispatch<React.SetStateAction<any>>
}

// create Context for file content
const FileContext = createContext<FileContextType | null>(null)

export const FileContextProvider: React.FC<{ children: ReactNode}> = ({ children }) => {
    const [homeFile, setHomeFile] = useState<string | null>(null)
    const [gitignore, setGitignore] = useState<string | null>(null)
    const [packagejson, setPackagejson] = useState<string | null>(null)
    const [tsconfigjson, setTsconfigjson] = useState<string | null>(null)
    const [appCss, setAppCss] = useState<string | null>(null)
    const [appTsx, setAppTsx] = useState<string | null>(null)
    const [indexTsx, setIndexTsx] = useState<string | null>(null)
    const [barChartFile, setBarChartFile] = useState<string | null>(null)
    const [donutChartFile, setDonutChartFile] = useState<string | null>(null)
    const [pieChartFile, setPieChartFile] = useState<string | null>(null)
    const [announcementFile, setAnnouncementFile] = useState<string | null>(null)
    const [knowledgeGraphFile, setKnowledgeGraphFile] = useState<string | null>(null)
    const [pocFile, setPocFile] = useState<string | null>(null)
    const [quicklinksFile, setQuicklinksFile] = useState<string | null>(null)
    const [listviewTableFile, setListviewTableFile] = useState<string | null>(null)
    const [tableCss, setTableCss] = useState<string | null>(null)
    const [pagesIndex, setPagesIndex] = useState<string | null>(null)
    const [router, setRouter] = useState<string | null>(null)
    const [menus, setMenus] = useState<string | null>(null)
    const [buttons, setButtons] = useState<string | null>(null)
    const [buttonsCss, setButtonsCss] = useState<string | null>(null)
    const [kpis, setKpis] = useState<string | null>(null)
    const [indexHtml, setIndexHtml] = useState<string | null>(null)
    const [manifestJson, setManifestJson] = useState<string | null>(null)
    const [robotsTxt, setRobotsTxt] = useState<string | null>(null)
    const [globalCss, setGlobalCss] = useState<string | null>(null)
    const [rhybusCss, setRhybusCss] = useState<string | null>(null)
    const [variableCss, setVariableCss] = useState<string | null>(null)
    const [reportWebVitals, setReportWebVitals] = useState<string | null>(null)
    const [customSelect, setCustomSelect] = useState<string | null>(null)
    const [inputCheckBox, setInputCheckBox] = useState<string | null>(null)
    const [inputText, setInputText] = useState<string | null>(null)
    const [inputTextarea, setInputTextarea] = useState<string | null>(null)
    const [inputLabel, setInputLabel] = useState<string | null>(null)
    const [inputSearch, setInputSearch] = useState<string | null>(null)
    const [inputSwitch, setInputSwitch] = useState<string | null>(null)
    const [pointsOfContact, setPointsOfContact] = useState<string | null>(null)
    const [quickLinks, setQuickLinks] = useState<string | null>(null)
    const [dashboardPage, setDashboardPage] = useState<string | null>(null)
    const [formPageComponents, setFormPageComponents] = useState<any>(null)
    
    return (
        <FileContext.Provider value={{
            homeFile,
            setHomeFile,
            reportWebVitals,
            setReportWebVitals,
            variableCss,
            setVariableCss,
            rhybusCss,
            setRhybusCss,
            globalCss,
            setGlobalCss,
            robotsTxt,
            setRobotsTxt,
            indexHtml,
            setIndexHtml,
            manifestJson,
            setManifestJson,
            packagejson,
            setPackagejson,
            gitignore,
            setGitignore,
            tsconfigjson,
            setTsconfigjson,
            appCss,
            setAppCss,
            appTsx,
            setAppTsx,
            indexTsx,
            setIndexTsx,
            barChartFile,
            setBarChartFile,
            donutChartFile,
            setDonutChartFile,
            pieChartFile,
            setPieChartFile,
            announcementFile,
            setAnnouncementFile,
            knowledgeGraphFile,
            setKnowledgeGraphFile,
            pocFile,
            setPocFile,
            quicklinksFile,
            setQuicklinksFile,
            listviewTableFile,
            setListviewTableFile,
            tableCss,
            setTableCss,
            pagesIndex,
            setPagesIndex,
            router,
            setRouter,
            menus,
            setMenus,
            buttons,
            setButtons,
            buttonsCss,
            setButtonsCss,
            kpis,
            setKpis,
            customSelect,
            setCustomSelect,
            inputCheckBox,
            setInputCheckBox,
            inputText,
            setInputText,
            inputLabel,
            setInputLabel,
            inputTextarea,
            setInputTextarea,
            inputSearch,
            setInputSearch,
            inputSwitch,
            setInputSwitch,
            pointsOfContact,
            setPointsOfContact,
            quickLinks,
            setQuickLinks,
            dashboardPage,
            setDashboardPage,
            formPageComponents,
            setFormPageComponents
        }}>
         {children}
        </FileContext.Provider>
    )
}

export const useFileContext = (): FileContextType => {
    const context = useContext(FileContext)
    if (context == null){
        throw new Error('useFileContext must be used within child elements of FileContextProvider')
    }
    return context
}
